'use client';
import Button from '@/app/components/ui/Button';
import { useWhatsAppLink } from '@/app/hooks/useWhatsAppLink';

export default function HeroSection() {
  const getWhatsAppLink = useWhatsAppLink();

  const handleSolicitarOrcamento = () => {
    const link = getWhatsAppLink();
    window.open(link, '_blank');
  }

  return (
    <section className="w-full relative">
      <div className="w-full bg-gradient-to-t from-[#02020c] to-transparent">
        <div className="w-full max-w-7xl mx-auto px-4 pt-[20px] sm:pt-[30px] lg:pt-[40px] pb-[40px] sm:pb-[60px] lg:pb-[80px]">
          <div className="flex flex-col items-center gap-[14px] sm:gap-[21px] lg:gap-[28px] w-full">
            {/* Trust Badge */}
            <div className="flex items-center gap-[4px] sm:gap-[6px] lg:gap-[8px]">
         
            </div>

            {/* Main Heading */}
            <div className="flex flex-col items-center gap-[10px] sm:gap-[15px] lg:gap-[20px] w-full max-w-4xl">
              <h1 className="text-3xl md:text-5xl lg:text-[64px] font-normal leading-tight text-center w-full" style={{ fontFamily: 'Raleway' }}>
                <span className="bg-gradient-to-b from-[#f7faff] to-[#9eb5dc] bg-clip-text text-transparent">IA & Comercial, para </span>
                <span className="text-[#ffffff] font-semibold italic">reduzir</span>
                <span className="bg-gradient-to-b from-[#f7faff] to-[#9eb5dc] bg-clip-text text-transparent"> seus custos e </span>
                <span className="text-[#ffffff] font-semibold italic">dobrar</span>
                <span className="bg-gradient-to-b from-[#f7faff] to-[#9eb5dc] bg-clip-text text-transparent"> seu lucro.</span>
              </h1>

              <p 
                className="text-base sm:text-lg lg:text-2xl font-normal leading-relaxed text-center text-[#b7c3d7] w-full max-w-2xl"
                style={{ fontFamily: 'Raleway' }}
              >
                Depois da internet, quem não está no digital não está em lugar nenhum. Na Evolutta, impulsionamos a sua empresa para que ela alcance todo o seu potencial.
              </p>
            </div>

            {/* CTA Button */}
            <Button
              onClick={handleSolicitarOrcamento}
              text_font_size="text-lg"
              text_font_family="Raleway"
              text_font_weight="font-normal"
              text_line_height="leading-base"
              text_text_align="center"
              text_color="text-primary-background"
              fill_background_color="bg-button-primary"
              border_border_radius="rounded-xl"
              padding="py-[14px] px-[34px] pr-[56px]"
              className="italic flex items-center gap-[10px] hover:opacity-90 transition-opacity duration-200 group"
            >
              <span className="group-hover:text-[#02020c] transition-colors duration-200">SOLICITAR RAIO-X OPERACIONAL</span>
              <img 
                src="/images/img_group_84.svg" 
                alt="Arrow" 
                className="w-[22px] h-[22px] group-hover:invert transition-all duration-200" 
              />
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}